import React, {Fragment} from 'react';
import {Text, View, StyleSheet } from '@react-pdf/renderer';

const borderColor = '#90e5fc'
const styles = StyleSheet.create({
    row: {
        flexDirection: 'row',
        borderBottomColor: '#bff0fd',
        borderBottomWidth: 1,
        alignItems: 'center',
        fontStyle: 'bold',
    },
    shareholder: {
        width: '20%',
        textAlign: 'left',
        borderRightColor: borderColor,
        borderRightWidth: 1,
    },
    description: {
        width: '20%',
        textAlign: 'left',
        borderRightColor: borderColor,
        borderRightWidth: 1,
    },
    qty: {
        width: '30%',
        borderRightColor: borderColor,
        borderRightWidth: 1,
        textAlign: 'right',
    },
    rate: {
        width: '15%',
        borderRightColor: borderColor,
        borderRightWidth: 1,
        textAlign: 'right',
    },
    amount: {
        width: '15%',
        textAlign: 'right',
    }
  });


const MemberTableRow = ({items}) => {
    const rows = items.map( item => 
        <View style={styles.row} key={item.id.toString()}>
            <Text style={styles.shareholder}>{item.name}</Text>
            <Text style={styles.description}>{item.roles}</Text>
            <Text style={styles.qty}>{item.address}</Text>
            <Text style={styles.rate}>{item.start_date}</Text>
            <Text style={styles.amount}>{item.end_date}</Text>
        </View>
    )
    return (<Fragment>{rows}</Fragment> )
};
  
  export default MemberTableRow